"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldDeadline = OfferFieldDeadline;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_intl_1 = require("react-intl");
const moment_1 = __importDefault(require("moment"));
const antd_1 = require("antd");
const styled_components_1 = require("styled-components");
const elements_1 = require("@src/components/elements");
const offer_1 = require("@src/types/offer");
const useConfig_1 = require("@src/hooks/useConfig");
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const offer_context_1 = require("../../../../offer-context");
const DatePickerStyleOverrides = (0, styled_components_1.createGlobalStyle) `
	.ant-picker-content {
		${({ highlightedDates }) => highlightedDates.map((date) => (0, styled_components_1.css) `
					td[title='${date}']:not(.ant-picker-cell-selected) {
						.ant-picker-cell-inner {
							border: 1px solid ${({ theme }) => theme.color.success};
						}
					}
				`)}
	}
`;
function OfferFieldDeadline({ isDisabled }) {
    const paymentType = (0, offer_context_1.useOfferContextValueSelector)(context => context.offer.paymentType.values.paymentType);
    const intl = (0, react_intl_1.useIntl)();
    const config = (0, useConfig_1.useConfig)();
    // @ts-ignore
    const { availableCredits } = (0, react_redux_1.useSelector)(state => state.admin.company);
    const { companyPremiumSettings } = (0, admin_context_1.useAdminContextValue)();
    const lastAvailableDay = paymentType === offer_1.OfferPaymentType.PAY_WITH_OFFER_CREDITS
        ? (0, moment_1.default)()
            .add(availableCredits * config.daysForOneCredit, 'days')
            .endOf('day')
        : (0, moment_1.default)().add(31, 'days').endOf('day');
    const highlightedDates = [...Array(availableCredits)].map((_, index) => (0, moment_1.default)()
        .add((index + 1) * config.daysForOneCredit, 'days')
        .format('YYYY-MM-DD'));
    const getDisabledDatesInterval = (current) => {
        if (companyPremiumSettings.hasFreeOfferPublishingEnabled) {
            return false;
        }
        const isPast = current && current.endOf('day').isBefore((0, moment_1.default)());
        const isAfterCreditLimit = current.isAfter(lastAvailableDay);
        return isPast || isAfterCreditLimit;
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { noStyle: true, shouldUpdate: (prevValues, curValues) => prevValues[offer_1.EOfferBasicInfoFormField.deadline] !== curValues[offer_1.EOfferBasicInfoFormField.deadline], children: ({ getFieldValue }) => {
            const deadline = getFieldValue(offer_1.EOfferBasicInfoFormField.deadline);
            const numberOfCreditsUsed = deadline
                ? Math.ceil(deadline.diff((0, moment_1.default)(), 'days') / config.daysForOneCredit)
                : 1;
            const isUsingMoreThanOneCredit = numberOfCreditsUsed > 1;
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(DatePickerStyleOverrides, { highlightedDates: highlightedDates }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                            id: 'admin.offer_form.deadline',
                        }), name: offer_1.EOfferBasicInfoFormField.deadline, rules: [
                            {
                                required: true,
                                message: intl.formatMessage({
                                    id: 'admin.offer_validation.please_fill_deadline',
                                }),
                            },
                        ], children: (0, jsx_runtime_1.jsx)(elements_1.DatePicker, { style: { width: '100%' }, format: "DD.MM.YYYY", disabled: isDisabled, disabledDate: getDisabledDatesInterval, placeholder: intl.formatMessage({
                                id: 'profile.resume.date',
                            }), showToday: false }) }), isUsingMoreThanOneCredit &&
                        !companyPremiumSettings.hasFreeOfferPublishingEnabled &&
                        !isDisabled && ((0, jsx_runtime_1.jsx)(elements_1.Alert, { className: "m-b-l", message: intl.formatMessage({ id: 'admin.offer_form.deadline.credits_used_warning' }, { numberOfCreditsUsed }), type: "warning", showIcon: true }))] }));
        } }));
}
